import { FieldProperty } from './field-property.model';
import { Link } from "./link.model";

export class Field {
  fieldId: number;
  isDisable: boolean;
  isHidden: boolean;
  isLocked: boolean;
  name: string; //^[a-zA-Z0-9]+(\-[a-zA-Z0-9]+)*
  partitioning: string;
  properties: FieldProperty;
  nested: Field[];
  _links: { [id: string]: Link };

  constructor(current?: any) {
    if (current) {
      Object.assign(this, current);
    } else {
      this.properties = new FieldProperty();
    }
  }

  public isLocalized(): boolean {
    return this.partitioning === 'language';
  }
}
